import React from "react";
import { Building2, Ruler, ShieldCheck, Zap, ThermometerSnowflake, Droplets } from "lucide-react";
import infraImg from "../assets/infrastructure.jpg";

const Infrastructure = () => {
  const specs = [
    { label: "Facility Scale", value: "60+ Controlled Pens", icon: <Building2 size={16} /> },
    { label: "Total Area", value: "Stall-Fed Unit", icon: <Ruler size={16} /> },
    { label: "Capacity", value: "600+ Head", icon: <Zap size={16} /> },
    { label: "Biosecurity", value: "ISO Standards", icon: <ShieldCheck size={16} /> },
  ];

  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
          <div className="max-w-2xl">
            <span className="text-[9px] font-black uppercase tracking-[0.4em] text-[#D4AF37] mb-2 block">
              Engineering Excellence
            </span>
            <h2 className="text-4xl font-black text-[#4B3621] tracking-tighter leading-tight">
              World-Class <span className="text-[#2D5A27]">Infrastructure.</span>
            </h2>
            <p className="mt-4 text-sm text-gray-500 font-medium leading-relaxed">
              Our facility features a precision-engineered environment optimized for 
              intensive stall-feeding with integrated waste management.
            </p>
          </div>
        </div>

        <div className="relative group overflow-hidden rounded-3xl border border-gray-100 shadow-xl mb-8">
          <div className="aspect-[21/7] md:aspect-[21/9] bg-gray-50">
            <img
              src={infraImg}
              alt="Facility Infrastructure"
              className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
            />
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {specs.map((spec, index) => (
            <div key={index} className="p-5 bg-[#FDFCF8] rounded-2xl border border-gray-100 hover:border-[#2D5A27] transition-all duration-300 group hover:shadow-md">
              <div className="w-8 h-8 bg-white rounded-lg shadow-sm flex items-center justify-center mb-4 text-[#2D5A27] group-hover:bg-[#2D5A27] group-hover:text-white transition-all">
                {spec.icon}
              </div>
              <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest mb-1">
                {spec.label}
              </p>
              <p className="text-base font-black text-[#4B3621]">
                {spec.value}
              </p>
            </div>
          ))}
        </div>


        <div className="mt-6 p-6 bg-[#4B3621] rounded-3xl flex flex-wrap gap-6 items-center justify-around text-white/80 shadow-lg">
          <div className="flex items-center gap-3">
            <ThermometerSnowflake size={16} className="text-[#D4AF37]" />
            <span className="text-[10px] font-bold uppercase tracking-widest">Climate Ventilation</span>
          </div>
          <div className="flex items-center gap-3">
            <Droplets size={16} className="text-[#D4AF37]" />
            <span className="text-[10px] font-bold uppercase tracking-widest">Automated Drainage</span>
          </div>
          <div className="flex items-center gap-3">
            <ShieldCheck size={16} className="text-[#D4AF37]" />
            <span className="text-[10px] font-bold uppercase tracking-widest">24/7 Surveillance</span>
          </div>
        </div>
        
      </div>
    </section>
  );
};

export default Infrastructure;